import {
  mapSeoData,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
import {
  defaultDynamicThreshold,
  safeParseToInt,
} from '@r-and-a-shared-ui/utils';

export const player_portals_page = (page: PLAYER_PORTALS_MODELS.Page) => {
  let dynamicThreshold = defaultDynamicThreshold;

  dynamicThreshold = safeParseToInt(
    process?.env?.NEXT_PUBLIC_DYNAMIC_LOAD_THRESHOLD ??
      `${defaultDynamicThreshold}`,
  );

  const bodyContent = page.elements?.body.linkedItems ?? [];

  const subheader = page.elements?.subheader_elements?.linkedItems ?? [];
  const sidebar = page.elements?.sidebar?.linkedItems ?? [];
  const preFooter = page.elements?.pre_footer_elements?.linkedItems ?? [];

  return {
    seo: mapSeoData(page),
    body: bodyContent.map((x, index) => {
      if (index >= dynamicThreshold) {
        return {
          ...x,
          dynamic: true,
        };
      }
      return x;
    }),
    sidebar,
    subheader,
    preFooter,
  };
};

export default player_portals_page;
